import type { ReactNode } from 'react'
import { useAppSelector } from '@/store/hooks'
import { RateLimitBanScreen } from './RateLimitBanScreen'

// Показывает заглушку «аккаунт во временном бане» вместо всего приложения
// (не отдельный роут): страницы сами шлют запросы, и забаненный юзер
// продолжал бы спамить 429 и продлевать бан.
export const RateLimitBanGate = ({ children }: { children: ReactNode }) => {
  const isBanned = useAppSelector((state) => state.rateLimit.isBanned)

  if (isBanned) return <RateLimitBanScreen />

  return <>{children}</>
}
